<template>
  <div class="main__section">
    <h1 class="section__title-low">
      {{ $t('analytics') }}
    </h1>
    <div class="main__body">
      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col">{{ $t('date-start-system') }}</th>
          <th scope="col">{{ $t('client-in-database') }}</th>
          <th scope="col">{{ $t('configured-segments') }}</th>
          <th scope="col">{{ $t('clients-with-phone') }}</th>
          <th scope="col">{{ $t('clients-with-email') }}</th>
          <th scope="col">{{ $t('total-clients-in-bots') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <th>{{ analytics.start }}</th>
          <td>{{ analytics.clientsInDb }}</td>
          <td>{{ analytics.countSegments }}</td>
          <td>{{ analytics.clientsWithNumber }}</td>
          <td>{{ analytics.clientsWithEmail }}</td>
          <td>{{ analytics.clientInBots }}</td>
        </tr>
        </tbody>
      </table>
      <div class="analytics none-background">
        <h2 class="analytics-title">{{ $t('total-messages-sent') }}</h2>
        <div class="social-block">
          <div class="social-item">
            <div class="social-img"><img src="@/assets/social/telegram.svg"></div>
            <div class="social-label"><label>Telegram</label></div>
            <div class="social-text">{{ this.analytics.messageTelegram }}</div>
          </div>
          <div class="social-item">
            <div class="social-img"><img src="@/assets/social/viber.svg"></div>
            <div class="social-label"><label>Viber</label></div>
            <div class="social-text">{{ this.analytics.messageViber }}</div>
          </div>
          <div class="social-item">
            <div class="social-img"><img src="@/assets/social/sms.svg"></div>
            <div class="social-label"><label>SMS</label></div>
            <div class="social-text">{{ this.analytics.messageSms }}</div>
          </div>
          <div class="social-item">
            <div class="social-img"><img src="@/assets/social/email.svg"></div>
            <div class="social-label"><label>Email</label></div>
            <div class="social-text">{{ this.analytics.messageEmail }}</div>
          </div>
        </div>
      </div>
      <div class="analytics background">
        <h2 class="analytics-title">{{ $t('total-requests-processed-automaticall') }}</h2>
        <div class="social-block">
          <div class="social-item">
            <div class="social-img"><img src="@/assets/social/telegram.svg"></div>
            <div class="social-label"><label>Telegram</label></div>
            <div class="social-text">{{ this.analytics.telegramBranch }}</div>
          </div>
          <div class="social-item">
            <div class="social-img"><img src="@/assets/social/viber.svg"></div>
            <div class="social-label"><label>Viber</label></div>
            <div class="social-text">{{ this.analytics.viberBranch }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'createTrigger',
  data: function () {
    return {
      analytics: {
        start: '',
        clientsInDb: 0,
        countSegments: 0,
        clientsWithNumber: 0,
        clientsWithEmail: 0,
        clientInBots: 0,
        messageTelegram: 0,
        messageViber: 0,
        messageSms: 0,
        messageEmail: 0,
        telegramBranch: 0,
        viberBranch: 0,
      },
    }
  },
  created() {
    this.getAnalyticsInfo();
  },
  methods: {
    getAnalyticsInfo: function () {
      axios.post('getAnalyticsInfo').then(response => {
        var status = response.data.status;
        if (status) {
          this.analytics.start = response.data.start;
          this.analytics.clientsInDb = response.data.clientsInDb;
          this.analytics.countSegments = response.data.countSegments;
          this.analytics.clientsWithNumber = response.data.clientsWithNumber;
          this.analytics.clientsWithEmail = response.data.clientsWithEmail;
          this.analytics.clientInBots = response.data.clientInBots;
          this.analytics.messageTelegram = response.data.messageTelegram;
          this.analytics.messageViber = response.data.messageViber;
          this.analytics.messageSms = response.data.messageSms;
          this.analytics.messageEmail = response.data.messageEmail;
          this.analytics.telegramBranch = response.data.telegramBranch;
          this.analytics.viberBranch = response.data.viberBranch;
        }
      });
    }
  }
}
</script>